import { computed } from 'vue';
import { useStore, useStoreGetters } from 'dashboard/composables/store';

/**
 * Composable for managing the kanban board/stage assigned to the current conversation
 * @returns {Object} An object containing methods and computed properties for conversation kanban
 */
export function useConversationKanban() {
  const store = useStore();
  const getters = useStoreGetters();

  const currentChat = computed(() => getters.getSelectedChat.value);
  const conversationId = computed(() => currentChat.value?.id);

  /**
   * Kanban boards the current user has access to, each with their nested stages
   * @type {import('vue').ComputedRef<Array>}
   */
  const kanbans = computed(() => getters['kanbans/getMyKanbans'].value);

  /**
   * The stage currently assigned to the conversation, if any
   * @type {import('vue').ComputedRef<Object|null>}
   */
  const currentKanbanStage = computed(
    () => currentChat.value?.meta?.kanban_stage || null
  );

  /**
   * Moves the current conversation to a kanban stage, or removes it from any
   * board when stage is null
   * @param {Object|null} stage
   */
  const moveToStage = stage => {
    store.dispatch('assignKanbanStage', {
      conversationId: conversationId.value,
      kanbanStageId: stage ? stage.id : null,
    });
  };

  return {
    kanbans,
    currentKanbanStage,
    moveToStage,
  };
}
